exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--34v9q5zp85R-GPd9t7T4XG {\n  display: flex;\n  gap: 2px;\n  flex-direction: column;\n}\n\nspan.care-team-tasks--3HwvFaY7lh1CyMRl0C3Pt4 {\n  display: inline-block;\n  width: 5.5em;\n}\n", ""]);

// exports
exports.locals = {
	"taskDates": "care-team-tasks--34v9q5zp85R-GPd9t7T4XG",
	"taskDates": "care-team-tasks--34v9q5zp85R-GPd9t7T4XG",
	"taskDateLabel": "care-team-tasks--3HwvFaY7lh1CyMRl0C3Pt4",
	"taskDateLabel": "care-team-tasks--3HwvFaY7lh1CyMRl0C3Pt4"
};